import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import { parseString } from "xml2js";
import api from "../../api";
import Property from "./Property";

class PropertiesSection extends Component {
  state = {
    addresses: [],
    activeIndex: 0,
    properties: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadSection = (node, props) => {
    const propData = _.get(
      node,
      "personReport.propertys[0].propertyRecords[0].records[0].property"
    );
    const propNodes = _.filter(
      propData,
      (p) =>
        _.get(p, "parcelId[0]", "") !== "" &&
        _.get(p, "record[0].deed[0].recordingDate[0].year[0]._") !== undefined
    );
    const orderedPropNodes = _.orderBy(
      propNodes,
      (e) => [e.record[0].deed[0].recordingDate[0].year[0]._, e.parcelId[0]],
      ["desc", "desc"]
    );
    const properties = [];
    const parcelIds = [];
    _.forEach(orderedPropNodes, (property) => {
      const parcelId = _.trim(_.get(property, "parcelId[0]"));
      if (_.findIndex(parcelIds, (pid) => pid === parcelId) === -1) {
        properties.push(property);
        parcelIds.push(parcelId);
      }
    });

    props.updateItemCountBySection(props.sectionName, properties.length);

    this.setState({
      properties,
    });
  };

  loadData = (props) => {
    const sectionNode = _.get(props.reportData, "personReport.propertys[0]");
    if (sectionNode) {
      this.loadSection(props.reportData, props);
    } else {
      const additionalData = _.cloneDeep(props.additionalData);
      additionalData.requestedSection = "properties";
      api.report
        .person(additionalData)
        .then((res) => {
          parseString(res.data, { async: false }, (err, rslt) => {
            this.loadSection(rslt, props);
          });
        })
        .catch((err) => console.log("properties res error - ", err));
    }
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    const propertiesElements = [];
    if (
      this.state.properties !== undefined &&
      this.state.properties.length > 0
    ) {
      const newProps = _.omit(this.props, "node");
      _.forEach(this.state.properties, (property, index) => {
        propertiesElements.push(
          <Property
            key={`rep_prop_${index}`}
            node={property}
            index={index}
            {...newProps}
          />
        );
      });
    } else {
      propertiesElements.push(
        <Table key={`no_recs_table`}>
          <Table.Body>
            <Table.Row key={`no_recs_row`}>
              <Table.Cell colSpan={100}>No Records found</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }
    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`ComTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Properties
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`ComBody`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>
              <Table.Row className="report-sub-section-header">
                <Table.HeaderCell>
                  Property Records Associated with Subject
                </Table.HeaderCell>
              </Table.Row>
            </Table.Body>
          </Table>
          {propertiesElements}
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default PropertiesSection;



// WEBPACK FOOTER //
// ./src/components/reports/PropertiesSection.js